import Icon from '../components/Icon.vue'

Icon.register({
  bullhorn: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M576 240C576 216.4 563 196 544 184.9V32C544 23.3 537 0 512 0 504.9 0 497.8 2.4 492 7L407 75.1C364.3 109.2 310.7 128 256 128H64C28.6 128 0 156.6 0 192V288C0 323.4 28.6 352 64 352H97.7C96.3 362.5 95.5 373.1 95.5 384 95.5 423.8 104.8 461.4 121.1 494.9 126.3 505.6 137.6 512 149.5 512H223.8C249.8 512 265.4 482.2 249.7 461.4 233.3 439.9 223.5 413.1 223.5 384 223.5 372.9 225.1 362.2 227.9 352H256C310.7 352 364.3 370.8 407 404.9L492 473A32-32 0 0 1 512 480C536.9 480 544 457.2 544 448V295.1C563 284 576 263.6 576 240zM480 381.4L446.9 355C392.9 311.8 325.1 288 256 288V192C325.1 192 392.9 168.2 446.9 125L480 98.6V381.4z'
      }
    ]
  }
})
